export enum EventType {
  SHIFT = "SHIFT",
  APPOINTMENT = "APPOINTMENT",
  BLOCK = "BLOCK",
  GOOGLE_CALENDAR = "GOOGLE_CALENDAR",
}

export enum BlockType {
  BREAK = "BREAK",
  MEAL = "MEAL",
  MEETING = "MEETING",
  TRAINING = "TRAINING",
  ADMIN = "ADMIN",
  MANAGER_APPROVED = "MANAGER_APPROVED",
  OTHER = "OTHER",
}

/** Block types that satisfy a location's shift break rules. */
export const BREAK_BLOCK_TYPES: readonly BlockType[] = [
  BlockType.BREAK,
  BlockType.MEAL,
];
export enum BreakPolicyMode {
  OFF = "OFF",
  SUGGEST = "SUGGEST",
  ENFORCE = "ENFORCE",
}

export enum EventStatus {
  PENDING = "PENDING",
  RESERVED = "RESERVED",
  CONFIRMED = "CONFIRMED",
  COMPLETED = "COMPLETED",
  NO_SHOW = "NO_SHOW",
  OVERRIDABLE = "OVERRIDABLE",
  CANCELLED = "CANCELLED",
}

export enum CustomizableEventStatus {
  PENDING = "PENDING",
  RESERVED = "RESERVED",
  CONFIRMED = "CONFIRMED",
  COMPLETED = "COMPLETED",
  NO_SHOW = "NO_SHOW",
  CANCELLED = "CANCELLED",
}

export enum EventAttributionSourceType {
  CALL = "CALL",
  SMS = "SMS",
  EMAIL = "EMAIL",
}

export enum EventIcon {
  BOOKING_FEE_PAID = "BOOKING_FEE_PAID",
  NEW_PATIENT = "NEW_PATIENT",
  SCHEDULED_BY_AI = "SCHEDULED_BY_AI",
  FORM_COMPLETED = "FORM_COMPLETED",
  FORM_NOT_COMPLETED = "FORM_NOT_COMPLETED",
  CHECKED_IN = "CHECKED_IN",
  ONLINE_BOOKING = "ONLINE_BOOKING",
  NOTE_LINKED = "NOTE_LINKED",
  PROVIDER_REQUESTED = "PROVIDER_REQUESTED",
}

export const EVENT_ICON_DESCRIPTIONS: Record<EventIcon, string> = {
  [EventIcon.BOOKING_FEE_PAID]: "Patient has paid the booking fee",
  [EventIcon.NEW_PATIENT]: "First appointment for this patient",
  [EventIcon.SCHEDULED_BY_AI]: "Appointment was booked by AI assistant",
  [EventIcon.FORM_COMPLETED]: "Patient has completed required forms",
  [EventIcon.FORM_NOT_COMPLETED]: "Patient has not completed required forms",
  [EventIcon.CHECKED_IN]: "Patient has checked in for appointment",
  [EventIcon.ONLINE_BOOKING]: "Patient self-scheduled online",
  [EventIcon.NOTE_LINKED]: "Appointment has a linked clinical note",
  [EventIcon.PROVIDER_REQUESTED]:
    "Patient specifically requested this provider when self-scheduling",
};

export enum EventSegmentType {
  SERVICE = "SERVICE",
  BOOKABLE = "BOOKABLE",
  PREP = "PREP",
  CLEANUP = "CLEANUP",
}
